import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "familyNo",
    headerName: "Family No(s)",
    width: 220,
    placeholder: "Enter Family No(s)",
  },
  {
    field: "paidBy",
    headerName: "Paid By",
    width: 220,
    placeholder: "Enter Paid By",
  },

  {
    field: "notes",
    headerName: "Notes",
    width: 360,
    placeholder: "Enter Notes",
  },
];

const Annuties = ({ mode }) => {
  const savedData = useSelector((state) => state.kotClient.annuties);
  return <ReusableDatagrid title="Annuities" columnsConfig={columnsConfig} initialRows={savedData} section={"annuties"} mode={mode} />;
};

export default Annuties;
